/**
 * http 请求插件
 */
import axios from "axios";
import routes from './../router/index'


let servers = {
    // local: 'http://localhost:8084/',
    dev: 'http://localhost:9630/',
    prod: `https://mwslapi.mingwo.cn/`,
	// prod: 'http://localhost:9630/',
};
//统一http请求配置
let http = axios.create({
    timeout: 30000,
    baseURL: ((typeof environment) == 'undefined') ? servers['prod'] : servers[environment]
});
// axios.apiUrl="http://test-weixin.bainuo.cn/";
// Add a request interceptor
http.interceptors.request.use(function (config) {
    let token = localStorage.getItem("token");
    if (token) {
        let loginTime=localStorage.getItem("loginTime");
        var nowTime = new Date().getTime();
        if (nowTime - loginTime >= 2880 * 60 * 1000) {
            //退出操作
            localStorage.removeItem("token");
            config.headers.sskey="";
            routes.push({name:'login'});
        } else {
            loginTime= nowTime;
            localStorage.setItem("loginTime",loginTime);
            config.headers.sskey =token;
        }
    }
    return config;
}, function (error) {
    console.error(error);
    return Promise.reject(error);
});

// Add a response interceptor
http.interceptors.response.use(function (response) {
    let result = imgUrlReplace(response.data);
    if (response.status == 200) {
        return result;
    } else {
        return Promise.reject(result);
    }
}, function (error) {
    return Promise.reject({
        status: "CLIENT_ERROR",
        message: error.message
    });
});

export default {

    install: function (Vue) {
        //为所有的Vue实例添加一个$http属性
        Vue.prototype.$http = http;
    },
};


function imgUrlReplace(row) {
    let data = JSON.stringify(row)
    data = data.replace(/coffer.bainuo.cn/ig,'coffer.mingwo.cn')
    data = data.replace(/coffer-cdn.bainuo.cn/ig,'coffer.mingwo.cn')
    return JSON.parse(data)
}


// WEBPACK FOOTER //
// ./src/libs/http.js